module.exports = __webpack_public_path__ + "img/title.a0c61659.png";